import { DefaultFetchService } from "app/services/fetchService";
interface ISuggestedDomainDataItem {
    Site: string;
    Favicon: string;
}

interface ISuggestedDomainsData {
    FromAlternativeSources: boolean;
    TotalCount: number;
    Data: ISuggestedDomainDataItem[];
}

interface IMarketBuilderService {
    getSuggestedDomains: (params: {
        keys: string[];
        country: string | number;
        results: number;
    }) => Promise<ISuggestedDomainsData>;
}

export default class MarketBuilderService implements IMarketBuilderService {
    private static _instance;
    protected fetchService;

    constructor() {
        this.fetchService = DefaultFetchService.getInstance();
    }

    public static getInstance(): MarketBuilderService {
        if (!MarketBuilderService._instance) {
            MarketBuilderService._instance = new MarketBuilderService();
        }
        return MarketBuilderService._instance;
    }

    public getSuggestedDomains(params: {
        keys: string[];
        country: string | number;
        results: number;
    }): Promise<ISuggestedDomainsData> {
        return this.fetchService.post("/api/MarketBuilder/Recommedations/Table", params);
    }
}
